import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { EULA_STATUS } from '~/features/devices/constants/eulaStatus';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';

interface EulaStatusProps {
    eulaStatus?: string;
}

const EULA_STATUS_CONFIG = {
    [EULA_STATUS.ACCEPTED]: {
        label: 'intl-msg:eulaStatus.accepted',
        className: 'label-success',
    },
    [EULA_STATUS.DECLINED]: {
        label: 'intl-msg:eulaStatus.declined',
        className: 'label-warning',
    },
    [EULA_STATUS.NOT_APPLICABLE]: {
        label: 'intl-msg:eulaStatus.notApplicable',
        className: 'label-info',
    },
};

const EulaStatus: React.FC<EulaStatusProps> = ({ eulaStatus }) => {
    if (!eulaStatus) {
        return <FieldOrNoData field={null} />;
    }

    const config = EULA_STATUS_CONFIG[eulaStatus];

    if (!config) {
        return <span>{eulaStatus}</span>;
    }

    return (
        <span className={classNames('label label-condensed', config.className)}>
            <FormattedMessage id={config.label} />
        </span>
    );
};

export default EulaStatus;
